var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMilitaryAndNationalSecurity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Aircraft-Military-Plane--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Aircraft Military Plane Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.88 16.41 -7.69 -7.67a0.26 0.26 0 0 1 -0.07 -0.15l-0.36 -3.34a0.22 0.22 0 0 0 -0.13 -0.19 0.24 0.24 0 0 0 -0.23 0 4.72 4.72 0 0 1 -2.28 0.59 4.71 4.71 0 0 1 -2.25 -0.58 0.25 0.25 0 0 0 -0.24 0 0.26 0.26 0 0 0 -0.13 0.2l-0.35 3.32a0.22 0.22 0 0 1 -0.08 0.15L1.13 16.4a1.79 1.79 0 0 0 -0.51 1.24 2 2 0 0 0 1.75 2h1.49a0.26 0.26 0 0 0 0.25 -0.25V17.9a2.5 2.5 0 0 1 2.5 -2.5h1a2.5 2.5 0 0 1 2.5 2.5v1.8a0.25 0.25 0 0 0 0.09 0.19 1 1 0 0 1 0.33 0.55l0.47 1.65a1 1 0 0 0 1 0.81h0.36a1 1 0 0 0 1 -0.81l0.44 -1.65a0.94 0.94 0 0 1 0.2 -0.54 0.27 0.27 0 0 0 0.08 -0.19V17.9a2.5 2.5 0 0 1 2.5 -2.5h1a2.5 2.5 0 0 1 2.5 2.5v1.49a0.26 0.26 0 0 0 0.25 0.25h1.25a2 2 0 0 0 1.75 -2 1.76 1.76 0 0 0 -0.45 -1.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 4.15a3.24 3.24 0 0 0 2.12 -0.81 0.26 0.26 0 0 0 0.06 -0.29A6.9 6.9 0 0 0 12.4 0.47a0.51 0.51 0 0 0 -0.53 0A7 7 0 0 0 10 3.06a0.24 0.24 0 0 0 0.06 0.29 3.23 3.23 0 0 0 2.06 0.8Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62 16.9h-1a1 1 0 0 0 -1 1v2.49a0.51 0.51 0 0 0 0.36 0.49 0.23 0.23 0 0 1 0.17 0.18l0.49 2.15a0.49 0.49 0 0 0 0.49 0.39 0.49 0.49 0 0 0 0.48 -0.39l0.48 -2.15a0.27 0.27 0 0 1 0.18 -0.19 0.5 0.5 0 0 0 0.36 -0.48V17.9a1 1 0 0 0 -1.01 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.63 16.9h-1a1 1 0 0 0 -1 1v2.49a0.5 0.5 0 0 0 0.36 0.48 0.27 0.27 0 0 1 0.18 0.19l0.48 2.15a0.49 0.49 0 0 0 0.48 0.39 0.49 0.49 0 0 0 0.49 -0.39l0.49 -2.15a0.23 0.23 0 0 1 0.17 -0.18 0.51 0.51 0 0 0 0.36 -0.49V17.9a1 1 0 0 0 -1.01 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMilitaryAndNationalSecurity);
export default ForwardRef;